<template>
  <VBlock
    class="notice-wrapper"
    :direction="Direction.column"
    :sort="Sort.left_center"
    :margin="[0, 0, 10, 0]"
    :padding="[15, 15, 5, 15]"
  >
    <VBlock
      v-for="(notice, i) in paymentNotices"
      :key="i"
      :direction="Direction.column"
      :sort="Sort.left_center"
      :margin="[0, 0, 10, 0]"
    >
      <VSpan :class="[getTitleClass(notice.type)]" :text="notice.message" :size="14" />
      <VSpan
        v-if="notice.type === 'HIGHLIGHT'"
        :class="[getClass(notice.type)]"
        :text="notice.subMessage"
        :size="14"
      />
    </VBlock>
  </VBlock>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSpan from '../../atoms/VSpan'

export default {
  name: 'PreOrderNotice',
  components: { VSpan, VBlock },
  methods: {
    getTitleClass(type) {
      switch (type) {
        case 'HIGHLIGHT':
          return 'highlight-title-text'
        case 'WARNING':
          return 'warning-title-text'
        case 'INFO':
          return 'info-title-text'
        default:
          return 'info-title-text'
      }
    },
    getClass(type) {
      switch (type) {
        case 'HIGHLIGHT':
          return 'highlight-text'
        case 'WARNING':
          return 'warning-text'
        case 'INFO':
          return 'info-text'
        default:
          return 'info-text'
      }
    }
  },
  props: {
    paymentNotices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.notice-wrapper {
  background-color: $white;
  border-bottom: 1px solid $light-gray-5;

  .highlight-title-text {
    color: $orange;
    font-weight: 800;
    letter-spacing: -0.4px;
  }
  .highlight-text {
    margin-top: -2px;
    font-weight: 800;
    letter-spacing: -0.4px;
    color: $gray-3;
  }

  .warning-title-text {
    position: relative;
    letter-spacing: -0.4px;
    color: $red;
    padding-left: 10px;

    &::before {
      position: absolute;
      left: 2px;
      top: 7px;
      content: '';
      width: 3px;
      height: 3px;
      margin: 0;
      background-color: $red;
      border-radius: 10px;
      display: block;
    }
  }
  .warning-text {
    letter-spacing: -0.4px;
    color: $red;
  }

  .info-title-text {
    position: relative;
    letter-spacing: -0.4px;
    color: $gray-3;
    padding-left: 10px;

    &::before {
      position: absolute;
      left: 2px;
      top: 7px;
      content: '';
      width: 3px;
      height: 3px;
      margin: 0;
      background-color: $gray-3;
      border-radius: 10px;
      display: block;
    }
  }
  .info-text {
    letter-spacing: -0.4px;
    color: $gray-3;
  }
}
</style>
